import { CurrentUser } from '../../../model/Common/common.interface'
import { n_lesson_prep } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

interface LessonPreparatioTutorBodyProps {
  currentUser: CurrentUser
  data: any
}

const TutorFeedbackTitle = {
  72: 'Words and Expression 단어와 표현',
  73: 'Grammatical Accuracy 문법 정확성',
  74: 'Sentence Variation 문장 다양성',
  75: 'Tone and Context 톤과 맥락',
  76: 'Pronunciation 발음',
  15: 'Test',
}
const TutorFeedbackTitleEn = {
  72: 'Words and Expression',
  73: 'Grammatical Accuracy',
  74: 'Sentence Variation',
  75: 'Tone and Context',
  76: 'Pronunciation',
  15: 'Test',
}
const LessonPreparationTutorBody = ({ currentUser, data }: LessonPreparatioTutorBodyProps) => {
  const { t, isLocaleKO } = useTranslation()
  const tutorFeedbackIds = data.feedquestion_ids?.map((item) => item.feedquestion_id)
  const tutorFeedback = data.overall_comment
  const tutorName = data.feedback_tutor_name
  const tutorCnt = data.same_tutor_count

  // 중복으로 나오는거 제거
  const uniquetutorFeedbackIds = tutorFeedbackIds?.filter((value, index, self) => {
    return self.indexOf(value) === index
  })

  return (
    <div className="flex flex-col space-y-24">
      {uniquetutorFeedbackIds?.length >= 1 && (
        <div className="flex-start flex-col space-y-8">
          <div className="text-[18px] font-bold">{t(n_lesson_prep.overview.study_category1)}</div>
          {uniquetutorFeedbackIds?.map((item, index) => {
            return (
              <div className="flex rounded-[8px] bg-blue-50 py-12 px-16 " key={index}>
                <div className="line-height-160 text-[14px] font-bold">
                  {isLocaleKO ? TutorFeedbackTitle[Number(item)] : TutorFeedbackTitleEn[Number(item)]}
                </div>
              </div>
            )
          })}
        </div>
      )}
      {tutorFeedback && (
        <div className="flex-start flex-col space-y-8">
          <div className="text-[18px] font-bold">
            {tutorCnt > 0
              ? t(n_lesson_prep.overview.feedback_category2(tutorName))
              : t(n_lesson_prep.overview.feedback_category1(tutorName))}
          </div>
          <div className="rounded-10 flex bg-gray-50 p-[16px]">
            <span
              className="gray-700 text-[16px] font-medium"
              dangerouslySetInnerHTML={{ __html: tutorFeedback }}
            ></span>
          </div>
        </div>
      )}
    </div>
  )
}

export default LessonPreparationTutorBody
